export default "__VITE_ASSET__TcabjL2I__"